module.exports = __webpack_public_path__ + "static/img/avatar_r_10.66f8997a.png";